export const GET_ADDRESS_DATA = 'GET_ADDRESS_DATA';
export const SET_ADDRESS_DATA_MUTATION = 'SET_ADDRESS_DATA_MUTATION';
export const GET_PERSONAL_DATA = 'GET_PERSONAL_DATA';
export const SET_PERSONAL_DATA_MUTATION = 'SET_PERSONAL_DATA_MUTATION';
export const GET_SHIPMENT_DATA = 'GET_SHIPMENT_DATA';
export const SET_SHIPMENT_DATA_MUTATION = 'SET_SHIPMENT_DATA_MUTATION';
export const GET_PERSONAL_VALID = 'GET_PERSONAL_VALID';
export const GET_ADDRESS_VALID = 'GET_ADDRESS_VALID';
export const GET_ORDER = 'GET_ORDER';
export const SET_ORDER_DATA_MUTATION = 'SET_ORDER_DATA_MUTATION';
export const STORE_ORDER_ACTION = 'STORE_ORDER_ACTION';
export const GET_ORDER_LOADING = 'GET_ORDER_LOADING';
export const SET_ORDER_LOADING_TO_TRUE_MUTATION = 'SET_ORDER_LOADING_TO_TRUE_MUTATION';
export const SET_ORDER_LOADING_TO_FALSE_MUTATION = 'SET_ORDER_LOADING_TO_FALSE_MUTATION';
export const RETREIVE_ORDER_ACTION = 'RETREIVE_ORDER_ACTION';
export const SET_PAYLANDS_PARAMS_MUTATION = 'SET_PAYLANDS_PARAMS_MUTATION';
export const GET_PAYLANDS_PARAMS = 'GET_PAYLANDS_PARAMS';
export const CREATE_PAYMENT_INSTANCE = 'CREATE_PAYMENT_INSTANCE';
export const GET_PAYMENT_METHOD = 'GET_PAYMENT_METHOD';
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const GET_BITCOIN_PARAMS = 'GET_BITCOIN_PARAMS';
export const SET_BITCOIN_PARAMS = 'SET_BITCOIN_PARAMS';
export const GET_CARDS = 'GET_CARDS';
export const SET_CARDS = 'SET_CARDS';
export const SET_SELECTED_CARD_UUID = 'SET_SELECTED_CARD_UUID';
export const GET_SELECTED_CARD_UUID = 'GET_SELECTED_CARD_UUID';
export const RETREIVE_REGIONS = 'RETREIVE_REGIONS';
export const GET_REGIONS = 'GET_REGIONS';
export const SET_REGIONS = 'SET_REGIONS';
export const RETREIVE_SHIPPING_TYPE = 'RETREIVE_SHIPPING_TYPE';
export const SET_SHIPPING_TYPE = 'SET_SHIPPING_TYPE';
export const GET_SHIPPING_TYPE = 'GET_SHIPPING_TYPE';
export const GET_COUPON = 'GET_COUPON';
export const GET_IS_CANARIAS = 'GET_IS_CANARIAS';
export const GET_FIELDS = 'GET_FIELDS';

